import { Injectable } from '@angular/core';
import { Observable, filter, take } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AbortManagerService {
    // Храним текущий ID для каждого типа запроса
    private requestCounters = new Map<string, number>();

    /**
     * Оборачиваем Observable, чтобы игнорировать устаревшие ответы
     * @param key Уникальный ключ запроса
     * @param source Исходный Observable
     */
    public cancellable<T>(key: string, source: Observable<T>): Observable<T> {
        // 1. Увеличиваем счётчик для этого ключа
        const currentId = (this.requestCounters.get(key) || 0) + 1;
        this.requestCounters.set(key, currentId);

        // 2. Возвращаем обёрнутый поток
        return source.pipe(
            // Пропускаем данные, только если ID ответа совпадает с текущим
            filter(() => currentId === (this.requestCounters.get(key) ?? 0)),
            // Берём только первое валидное значение и завершаем
            take(1),
            // Если фильтр отсёк всё — поток завершится без эмита.
        );
    }

    /**
     * (Опционально) Получить текущий ID запроса для отладки
     */
    public getCurrentId(key: string): number | undefined {
        return this.requestCounters.get(key);
    }

    /** Сбросить счётчик (если нужно) */
    public reset(key: string) {
        this.requestCounters.delete(key);
    }
}
